import { ConsentCheckboxItem, ConsentLink } from '@/shared/types/IFormData';
import { FieldValues, UseFormRegister } from 'react-hook-form';
import { memo, useCallback, KeyboardEvent } from 'react';

import './ConsentCheckbox.css';

type Props = {
  texts?: ConsentCheckboxItem[];
  onAgreementButtonClick?: (label: ConsentLink['label']) => void;
  register?: UseFormRegister<FieldValues>;
};

const fieldName = 'consent';

export const ConsentCheckbox = memo(
  ({ texts = [], onAgreementButtonClick, register }: Props) => {
    if (!texts.length) return null;

    const handleLinkClick = useCallback(
      (label: ConsentLink['label']) => () => onAgreementButtonClick?.(label),
      [onAgreementButtonClick]
    );

    const handleKeyDown = (
      label: ConsentLink['label']
    ) => (e: KeyboardEvent<HTMLButtonElement>) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onAgreementButtonClick?.(label);
      }
    };

    return (
      <div className="consent-checkbox-wrapper">
        <div className="consent-checkbox__container">
          <input
            id={fieldName}
            type="checkbox"
            className="consent-checkbox__input"
            // Если форму контролирует RHF — он сам следит за required
            required
            {...register?.(fieldName)}
            aria-describedby={`${fieldName}-label`}
          />

          <label
            id={`${fieldName}-label`}
            htmlFor={fieldName}
            className="consent-checkbox__label"
          >
            {texts.map((item, idx) =>
              typeof item === 'string' ? (
                <span key={`${idx}_${item}`}>{item}</span>
              ) : (
                <button
                  key={item.id}
                  type="button"
                  role="button"
                  tabIndex={0}
                  className="consent-checkbox__button"
                  onClick={handleLinkClick(item.label)}
                  onKeyDown={handleKeyDown(item.label)}
                  aria-label={item.text}
                >
                  {item.text}
                </button>
              )
            )}
          </label>
        </div>
      </div>
    );
  }
);
